module.exports = __webpack_public_path__ + "static/img/amgo_sgp.947357fd.png";